import { useTranslations } from "@/i18n/LocaleProvider";

export default function BatchPaymentStep({
  bookingReference,
  loading,
  onPay,
}: {
  bookingReference: string;
  loading: boolean;
  onPay: () => void;
}) {
  const { t } = useTranslations();
  return (
    <div className="mt-8 space-y-4">
      <h1 className="font-display text-3xl">{t("batches.payment.title")}</h1>
      <p>
        {t("batches.payment.noticeBefore")} <strong>{bookingReference}</strong>
        {t("batches.payment.noticeAfter")}
      </p>
      <button
        onClick={onPay}
        disabled={loading}
        className="rounded-xl bg-accent px-6 py-3 font-semibold text-accent-foreground disabled:opacity-50"
      >
        {loading ? t("batches.payment.payLoading") : t("batches.payment.payIdle")}
      </button>
    </div>
  );
}
